<template>
    <div class="h5">
        <a :href="url" :class="{isActive: isActive}">打开小程序</a>
    </div>
</template>
<script>
(function(designWidth, maxWidth) {
  var doc = document,
  win = window,
  docEl = doc.documentElement,
  remStyle = document.createElement("style"),
  tid;

  function refreshRem() {
    var width = docEl.getBoundingClientRect().width;
    maxWidth = maxWidth || 540;
    width>maxWidth && (width=maxWidth);
    var rem = width * 100 / designWidth;
    remStyle.innerHTML = 'html{font-size:' + rem + 'px;}';
  }

  if (docEl.firstElementChild) {
    docEl.firstElementChild.appendChild(remStyle);
  } else {
    var wrap = doc.createElement("div");
    wrap.appendChild(remStyle);
    doc.write(wrap.innerHTML);
    wrap = null;
  }
  //要等 wiewport 设置好后才能执行 refreshRem，不然 refreshRem 会执行2次；
  refreshRem();

  win.addEventListener("resize", function() {
    clearTimeout(tid); //防止执行两次
    tid = setTimeout(refreshRem, 300);
  }, false);

  win.addEventListener("pageshow", function(e) {
    if (e.persisted) { // 浏览器后退的时候重新计算
      clearTimeout(tid);
      tid = setTimeout(refreshRem, 300);
    }
  }, false);

  if (doc.readyState === "complete") {
    doc.body.style.fontSize = "16px";
  } else {
    doc.addEventListener("DOMContentLoaded", function(e) {
      doc.body.style.fontSize = "16px";
    }, false);
  }
})(750, 750);
export default {
    data() {
        return {
            url: 'javascript:void(0)',
            isActive: false,
        }
    },
    created() {
        let url = window.location.href.slice(window.location.href.indexOf('?')+1);
        let arr = url.split('&');
        let obj = {};
        for(let i of arr){
            let key = i.slice(0, i.indexOf('=')),
                value = i.slice(i.indexOf('=')+1);
            obj[key] = value;
        }
        let params = {
          key: obj.u,
          code: obj.c
        };
        this.getQrcode(params);
    },
    methods: {
        getQrcode(params){
            this.$http.post(this.common.admin + '/api/getMiniProgramScheme', params).then(res => {
                if(res.code === 200){
                    this.url = res.data.url_scheme;
                    this.isActive = true;
                }else{
                    this.isActive = false;
                    return this.$message.error('该电桩处于故障中，请更换电桩');
                }
            });
        }
    },
}
</script>
<style lang="less" scoped>
    .h5{
        width: 100%;
        height: 100%;
        background: url('./../../assets/img/chargeH5Bg.png') no-repeat;
        background-position: 0 0;
        background-size: 100% 100%;

        position: relative;

        .btn,
        a{
            position: absolute;
            left: 50%;
            bottom: 1rem;
            transform: translateX(-50%);

            display: flex; 
            justify-content: center;
            align-items: center;
            width: 5rem;
            height: 1rem;
            border-radius: 0.5rem;
            font-size: 0.36rem;
            font-weight: bold;
            text-decoration: none;
            background-color: #8bc7dd;
            color: #5bb7b7;


            &.isActive{
                background: #FFFFFF;
                color: #13A78C;    
            }
        }
    }
</style>